import theme from 'styled-theming'
import { rgba } from 'polished'

export const backdrop = theme('mode', {
  light: rgba('#52676F', 0.5),
  dark: rgba('#52676F', 0.5),
})
